export default "__VITE_ASSET__cvEVwjmF__"